import { render, staticRenderFns } from "./PI2.vue?vue&type=template&id=2dc1c044&scoped=true&"
import script from "./PI2.vue?vue&type=script&lang=js&"
export * from "./PI2.vue?vue&type=script&lang=js&"
import style0 from "./PI2.vue?vue&type=style&index=0&id=2dc1c044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1c044",
  null
  
)

export default component.exports